/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FilterType} from "../../../../data/finders.model";
import Block from "../../../atoms/layout/Block";
import SelectedTags from "../../../molecules/finder/SelectedTags";
import {ShowHide} from "../../../atoms/layout/ShowHide";
import {TagType} from "../../../../data/aem.model";
import {connect} from "react-redux";
import {openFinderPanel} from "../../../../actions/finder";
import {withI18N} from "../../../hoc/withI18N";
import {compose} from "redux";
import {InformationIcon} from "../../../molecules/finder/InformationIcon";


class _FilterContainer extends React.Component {

    static propTypes = {
        filter: PropTypes.oneOfType([PropTypes.shape(FilterType), PropTypes.object]),
        selected: PropTypes.arrayOf(PropTypes.shape(TagType)),
        toggleTag: PropTypes.func,
        parentTagTitle: PropTypes.string,
        defaultOpen: PropTypes.bool,
        collapsible: PropTypes.bool,
        showSearchItemAsFilter: PropTypes.bool,
        searchTerm: PropTypes.string,
        setSearch: PropTypes.func
    };

    static defaultProps = {
        filter: {},
        selected: [],
        parentTagTitle: null,
        defaultOpen: false,
        collapsible: true
    };

    constructor(props) {
        super(props);

        this.state = {
            collapsed: true
        };
    }

    componentDidMount() {
        this.setState({collapsed: !this.props.defaultOpen});
    };

    toggleCollapse = () => this.props.collapsible && this.setState({collapsed: !this.state.collapsed});

    render() {
        const {filter, selected, toggleTag, parentTagTitle, collapsible, children, showSearchItemAsFilter, searchTerm, setSearch} = this.props;
        const {collapsed} = this.state;

        const title = filter.title || parentTagTitle || (filter.tags.length > 0 && filter.tags[0] && filter.tags[0].title) || "";

        return <Block className={`finder__filter filter-container-${filter.type.toLowerCase()}`}>
            <Block className="finder__filter-container-header">
                <Block className={"p-flex p-justify-space-between " + (collapsible ? "collapsible" : "")}
                       onClick={this.toggleCollapse}>
                    <span className={"text-small-semi-bold"}>{title}</span>
                    {filter.informationIcon && <InformationIcon message={filter.informationIcon} type="INFO"/>}
                </Block>
            </Block>
            <Block className={!collapsed ? "finder__filter-container-body open" : "finder__filter-container-body"}>
                <ShowHide show={!collapsed}>
                    {children}
                    <ShowHide show={selected?.length > 0 || searchTerm}>
                        <Block className="tag-list__selected-tags">
                            <SelectedTags key="selected-tags" selected={selected} onTagSelect={toggleTag}
                                          showSearchItemAsFilter={showSearchItemAsFilter} searchTerm={searchTerm}
                                          setSearch={setSearch}/>
                        </Block>
                    </ShowHide>
                </ShowHide>
            </Block>
        </Block>
    }
}

export const FilterContainer = compose(connect(undefined, {openFinderPanel}), withI18N)(_FilterContainer);
